// This config is used by
//  - HeaderNav.jsx to determine is links should be shown.
//    (there are also conditional statements in the footer and secondary nav)
//  - Promotions.jx to determine if a promo card should be shown.
//  - EvenetFinished banner component on expired event/promo pages.
// This allows us to define a publish schedule in advance and have these components show/hide.
// The schedule is based on the current date and time. EX: unpublish_at: "2025-03-19T16:42:00" // please use this example set the time if needed

const scheduleConfig = {
  // Entertainment
  musicalMonday: {
    publish_at: "2024-01-01",
    unpublish_at: "2021-09-06"
  },
  girlsNightOut: {
    publish_at: "2024-01-01",
    unpublish_at: "2024-12-11"
  },
  newYearsEve2025: {
    // Don't delete this key,
    // it is used in Cypress tests
    // schedule-promo-config.cy.js
    publish_at: "2024-11-01",
    unpublish_at: "2025-01-01",
  },
  newYearsEve2026: {
    publish_at: "2025-11-01",
    unpublish_at: "2026-01-01",
  },
  newYearsEve2027: {
    publish_at: "2026-10-29",
    unpublish_at: "2027-01-01",
  },
  valentines2025: {
    publish_at: "2025-01-24",
    unpublish_at: "2025-02-15"
  },
  valentines2026: {
    publish_at: "2026-01-19",
    unpublish_at: "2026-02-15T23:59:00"
  },
  bigGameBash2025: {
    publish_at: "2025-01-27",
    unpublish_at: "2025-02-10"
  },
  bigGameBash2026: {
    publish_at: "2026-01-16",
    unpublish_at: "2026-02-08T23:30:00"
  },
  fightQuest61: {
    publish_at: "2026-05-21",
    unpublish_at: "2026-06-13T23:59:00"
  },
  hockeyNightAtTheRail2024: {
    publish_at: "2024-01-01",
    unpublish_at: "2025-04-30"
  },
  // Dining
  allYouCanEat2025: {
    publish_at: "2025-10-30",
    unpublish_at: "2026-04-16"
  },
  lunchSpecial2025: {
    publish_at: "2025-04-25T16:10:00",
    unpublish_at: "2025-04-29T16:00:00"
  },
  fiveOr7_2025: {
    publish_at: "2025-11-24"
  },
  freePlayLunch2025: {
    publish_at: "2025-08-29T14:00:00",
    unpublish_at: "2025-11-29"
  },
  lobsterSpecial2025: {
    publish_at: "2025-02-25",
    unpublish_at: "2025-07-01"
  },
  surfAndTurf2024: {
    publish_at: "2024-09-19",
    unpublish_at: "2025-06-26"
  },
  playgroundBuffets: {
    publish_at: "2024-09-19"
  },
  get25PercentOff: {
    publish_at: "2024-09-19",
    unpublish_at: "2025-05-19"
  },
  earlyBirdBreakfastSpecial: {
    publish_at: "2024-09-19"
  },
  classicAmericanBreakfast: {
    publish_at: "2024-09-19"
  },
  earlyBirdSpecial: {
    publish_at: "2024-09-19",
    unpublish_at: "2024-10-29"
  },
  dragonDiceNights: {
    publish_at: "2024-09-26",
    unpublish_at: "2025-12-26"
  },
  freeBurgerPromo2025: {
    publish_at: "2025-06-26",
    unpublish_at: "2026-01-28"
  },
  surfAndTurf2025: {
    publish_at: "2025-06-27",
    unpublish_at: "2026-03-30"
  },
  steakFriesSpecial2025: {
    publish_at: "2025-06-30",
    unpublish_at: "2025-09-30"
  },
  wine50OffEtc2025: {
    publish_at: "2026-10-09",
  },
  etcSteakFritesSpecial2026: {
    publish_at: "2026-09-30",
    unpublish_at: "2026-11-27"
  },
  cocktailsDrinks50Off2026: {
    publish_at: "2026-02-11"
  },
  playersChoiceFall2026: {
    publish_at: "2026-09-29"
  },
  filetMignonSpecial2025: {
    publish_at: "2025-07-30",
    unpublish_at: "2025-10-30"
  },
  freeRotisserieChicken2025: {
    publish_at: "2025-09-26",
    unpublish_at: "2026-01-27"
  },
  freeChickenParmesan2026: {
    publish_at: "2026-01-01",
    unpublish_at: "2026-06-30"
  },
  freeFishAndChips2026: {
    publish_at: "2026-01-20",
    unpublish_at: "2026-07-01T23:59:00"
  },
  freeBbqBrisket2026: {
    publish_at: "2026-06-30T09:00:00",
  },
  freeLobsterAndShrimpRoll2026: {
    publish_at: "2026-07-01",
    unpublish_at: "2026-09-30"
  },
  freeBbqRibs2026: {
    publish_at: "2026-01-28",
  },
  freeBeefMeltSandwich2026: {
    publish_at: "2026-09-30",
  },
  // Poker
  mysteryHighHandOctober2024: {
    // EXAMPLE WITH TIME
    // REMEMBER TO PUT THE T
    publish_at: "2024-01-01",
    unpublish_at: "2021-11-29T15:16:00"

  },
  highHandDecember2024: {
    publish_at: "2024-11-22",
    unpublish_at: "2025-01-01"
  },
  highHandJanuary2025: {
    publish_at: "2024-11-22",
    unpublish_at: "2025-02-01"
  },
  highHandMarch2025: {
    publish_at: "2024-02-26",
    unpublish_at: "2025-04-01"
  },
  highHandApril2025: {
    publish_at: "2025-03-25",
    unpublish_at: "2025-05-01"
  },
  highHandJuly2025: {
    publish_at: "2025-07-17",
    unpublish_at: "2025-08-04T03:00:00"
  },
  highHandNovember2025: {
    publish_at: "2025-10-30",
    unpublish_at: "2025-11-18T03:00:00"
  },
  nationalPokerDay2025: {
    publish_at: "2025-03-25",
    unpublish_at: "2025-04-20"
  },
  nationalPokerDay2026: {
    publish_at: "2026-03-19T12:00:00",
    unpublish_at: "2026-04-22T03:00:00"
  },
  anniversaryHighHandDec2024: {
    publish_at: "2024-11-22",
    unpublish_at: "2024-12-18"
  },
  irishOpen2025: {
    publish_at: "2024-12-18",
    unpublish_at: "2025-02-26"
  },
  mainEventMaynia2025: {
    publish_at: "2025-04-01",
    unpublish_at: "2025-06-09"
  },
  pokerTlb: {
    // Don't delete this key,
    // it is used in Cypress tests
    // schedule-nav-config.cy.js
    publish_at: "2026-09-11",
    unpublish_at: "2026-11-16T23:59:00"
  },
  badBeatJackpot: {
    publish_at: "2024-09-19"
  },
  pokerNewYearsEve2025: {
    // Don't delete this key,
    // it is used in Cypress tests
    // schedule-promo-config.cy.js
    publish_at: "2024-11-01",
    unpublish_at: "2025-01-01",
  },
  worldCupOfCards2025: {
    publish_at: "2024-01-01",
    unpublish_at: "2025-02-03",
  },
  wsopcPlaygroundSpring2025: {
    publish_at: "2025-01-21",
    unpublish_at: "2025-04-09",
  },
  wsopcPlaygroundSpring2025Giveaway: {
    publish_at: "2025-01-21",
    unpublish_at: "2025-03-22",
  },
  titanTuesday2025: {
    publish_at: "2025-01-10",
  },
  titanTuesday2026: {
    publish_at: "2026-05-13",
    unpublish_at: "2026-10-22",
  },
  titanTuesdayMarch2026: {
    publish_at: "2026-02-25",
    unpublish_at: "2026-03-18",
  },
  titanTuesdayMay2026: {
    publish_at: "2026-04-09",
    unpublish_at: "2026-05-06T03:00:00",
  },
  hockeyNightAtPlayground2025: {
    publish_at: "2025-09-26T05:00:00-04:00",
    unpublish_at: "2026-04-15T00:01:00-04:00"
  },
  hockeyNightPlaygroundPlayoffs2026: {
    publish_at: "2026-04-17",
    unpublish_at: "2026-06-01"
  },
  hockeyNightAtPlayground2026: {
    publish_at: "2026-09-25T05:00:00-04:00",
    unpublish_at: "2027-04-01T00:01:00-04:00"
  },
  springBreakPowerWeeks2025: {
    publish_at: "2025-01-28",
    unpublish_at: "2025-03-10",
  },
  springBreakPowerWeeks2026: {
    publish_at: "2026-01-07",
    unpublish_at: "2026-03-09T09:00:00",
  },
  highHandFebruary2025: {
    publish_at: "2025-01-30",
    unpublish_at: "2025-03-01"
  },
  moneyMakerTour2025: {
    publish_at: "2025-02-22",
    unpublish_at: "2025-05-21"
  },
  multiMillionaireMaker2025: {
    publish_at: "2025-04-22",
    unpublish_at: "2025-06-02"
  },
  multiMillionaireMakerAugust2025: {
    publish_at: "2025-07-28T13:00:00",
    unpublish_at: "2025-08-17T19:00:00"
  },
  multiMillionaireMakerSeptember2025: {
    publish_at: "2025-09-04T13:00:00",
    unpublish_at: "2025-09-28T19:00:00"
  },
  tripleBarrelCashBlast2025: {
    publish_at: "2025-10-16T09:00:00",
    unpublish_at: "2025-11-02T22:30:00"
  },
  tripleBarrelCashBlast2025AnniversaryEdition: {
    publish_at: "2025-11-12",
    unpublish_at: "2025-12-18T01:30:00"
  },
  tripleBarrelCashBlast2026: {
    publish_at: "2025-12-12",
    unpublish_at: "2026-01-18T22:00:00"
  },
  tripleBarrelCashBlastFebruary2026: {
    publish_at: "2026-01-15",
    unpublish_at: "2026-03-01T22:00:00"
  },
  tripleBarrelCashBlastMarch2026: {
    publish_at: "2026-02-24",
    unpublish_at: "2026-03-22T22:00:00"
  },
  wptGlobalSummerMillion2025: {
    publish_at: "2025-05-23",
    unpublish_at: "2025-08-04"
  },
  wptGlobalWinterClassic2026: {
    publish_at: "2025-12-08",
    unpublish_at: "2026-02-02T09:00:00"
  },
  powerWeeksJune2025: {
    publish_at: "2025-05-21",
    unpublish_at: "2025-07-02"
  },
  highHandJune2025: {
    publish_at: "2025-05-28",
    unpublish_at: "2025-06-13T14:00:00"
  },
  megaHighHandJune2025: {
    publish_at: "2025-06-12",
    unpublish_at: "2025-06-30T03:00:00"
  },
  megaHighHandJuly2025: {
    publish_at: "2025-06-27",
    unpublish_at: "2025-07-21T02:00:00"
  },
  wsopcMontrealGGPoker2025: {
    publish_at: "2025-06-13",
    unpublish_at: "2025-09-03"
  },
  msptCanadianPokerChampionship2025: {
    publish_at: "2025-09-03",
    unpublish_at: "2025-10-20T09:00:00"
  },
  wsopcPlaygroundFall2025: {
    publish_at: "2025-10-07",
    unpublish_at: "2025-11-19T08:00:00"
  },
  "15yearAnniversarySeries2025": {
    publish_at: "2025-11-10",
    unpublish_at: "2025-12-17T09:00:00"
  },
  wsopcPlaygroundSpring2026: {
    publish_at: "2025-11-26",
    unpublish_at: "2026-04-08T09:00:00"
  },
  wsopcPlaygroundMay2026: {
    publish_at: "2026-03-26",
    unpublish_at: "2026-05-26T09:00:00"
  },
  summerMillion2026: {
    publish_at: "2026-05-08",
    unpublish_at: "2026-07-27T09:00:00"
  },
  anniversarySeries2026: {
    publish_at: "2026-10-29",
    unpublish_at: "2026-12-22T09:00:00"
  },
  msptCanadianPokerChampionship2026: {
    publish_at: "2026-09-03",
    unpublish_at: "2026-10-13T08:00:00"
  },
  highHandSummer2026: {
    publish_at: "2026-05-14",
    unpublish_at: "2026-08-23T05:00:00"
  },
  highHandFall2026: {
    publish_at: "2026-09-13T09:00:00",
  },
  wsopcPlaygroundMay2026CreatorChampionship: {
    publish_at: "2026-04-03",
    unpublish_at: "2026-09-10T09:00:00"
  },
  wsopSuperCircuitCanada2026: {
    publish_at: "2026-01-23",
    unpublish_at: "2026-09-13T09:00:00"
  },
  wsopcPlaygroundNovember2026: {
    publish_at: "2026-09-08",
    unpublish_at: "2026-11-17T09:00:00"
  },
  luxonPayGiveaway2026: {
    publish_at: "2026-07-16",
    unpublish_at: "2026-07-29"
  },
  // EGD
  chaseTheAce2024: {
    publish_at: "2024-09-19",
    unpublish_at: "2024-12-20"
  },
  chineseNewYear2025: {
    publish_at: "2025-01-03",
    unpublish_at: "2025-02-17"
  },
  chineseNewYear2026: {
    publish_at: "2026-02-13",
    unpublish_at: "2026-03-03T23:59:00"
  },
  saintPatricksDay2025: {
    publish_at: "2025-03-03",
    unpublish_at: "2025-03-18"
  },
  saintPatricksDay2026: {
    publish_at: "2026-02-27",
    unpublish_at: "2026-03-17T21:00:00"
  },
  easterEggStravaganza2026: {
    publish_at: "2026-03-12",
    unpublish_at: "2026-04-05T18:00:00"
  },
  spinAndSpoilMom2025: {
    publish_at: "2025-04-01",
    unpublish_at: "2025-05-12"
  },
  cashnadoSpring2026: {
    publish_at: "2026-04-21",
    unpublish_at: "2026-07-03T22:00:00"
  },
  cashnado2026: {
    publish_at: "2026-06-30",
    unpublish_at: "2027-01-01T22:00:00"
  },
  spinAndSpoilMom2026: {
    publish_at: "2026-04-03",
    unpublish_at: "2026-05-10T19:00:00"
  },
  downloadAndWin2026: {
    publish_at: "2026-04-23",
    unpublish_at: "2026-05-25T23:59:00"
  },
  nclCruiseMarch2026: {
    publish_at: "2026-02-05",
    unpublish_at: "2026-03-10T21:00:00"
  },
  nclCruiseSeptember2026: {
    publish_at: "2026-08-27",
    unpublish_at: "2026-09-22T21:00:00"
  },
  mscCruiseApril2026: {
    publish_at: "2026-03-10",
    unpublish_at: "2026-04-21T22:00:00"
  },
  mscCruiseOctober2026: {
    publish_at: "2026-09-24",
    unpublish_at: "2026-10-27T22:00:00"
  },
  rcgCruiseJuly2026: {
    publish_at: "2026-05-29",
    unpublish_at: "2026-06-30T21:00:00"
  },
  rcgCruiseNovember2026: {
    publish_at: "2026-10-22",
    unpublish_at: "2026-11-24T21:00:00"
  },
  rcgCruiseNovember2026Rsvp: {
    publish_at: "2026-10-22",
    unpublish_at: "2026-11-24T21:00:00"
  },
  rcgCruiseJuly2026Rsvp: {
    publish_at: "2026-06-12",
    unpublish_at: "2026-06-30T21:00:00"
  },
  nclCruiseSeptember2026Rsvp: {
    publish_at: "2026-08-27",
    unpublish_at: "2026-09-22T21:00:00"
  },
  mscCruiseOctober2026Rsvp: {
    publish_at: "2026-09-23",
    unpublish_at: "2026-10-27T21:00:00"
  },
  spinAndSpoilMom2025Buffet: {
    publish_at: "2025-04-01",
    unpublish_at: "2025-05-12"
  },
  nuitElite: {
    publish_at: "2025-04-29",
    unpublish_at: "2025-06-24"
  },
  clubElite2025: {
    publish_at: "2025-10-31"
  },
  birthdayBash2025: {
    publish_at: "2025-05-05"
  },
  ladiesNight2025: {
    publish_at: "2025-06-06",
    unpublish_at: "2025-09-30"
  },
  winningWednesday: {
    publish_at: "2025-07-11"
  },
  easterEggStravaganza2025: {
    publish_at: "2025-03-14",
    unpublish_at: "2025-04-21"
  },
  weeklyJackpotParty: {
    publish_at: "2024-09-19",
    unpublish_at: "2025-07-10"
  },
  jackpotParty: {
    publish_at: "2025-07-10"
  },
  instaWin: {
    publish_at: "2024-09-19"
  },
  boomingWednesday: {
    publish_at: "2024-09-19",
    unpublish_at: "2025-07-11"
  },
  optInAndWin: {
    publish_at: "2024-09-19"
  },
  followForFreePlay: {
    publish_at: "2024-09-19"
  },
  happyBirthday: {
    publish_at: "2024-09-19",
    unpublish_at: "2025-05-14"
  },
  welcomeBackBonus: {
    publish_at: "2026-01-05"
  },
  dragonAfterHours2025: {
    publish_at: "2025-05-14",
    unpublish_at: "2026-04-21"
  },
  ultimateDad2025: {
    publish_at: "2026-05-21",
    unpublish_at: "2025-06-13"
  },
  ultimateDad2026: {
    publish_at: "2026-05-21",
    unpublish_at: "2026-06-19T00:00:00"
  },
  gpFreePlay2025: {
    publish_at: "2025-05-29",
    unpublish_at: "202-06-15"
  },
  gpFreePlay2026: {
    publish_at: "2026-05-14",
    unpublish_at: "2026-05-22T22:15:00"
  },
  multiplierFridays2025: {
    publish_at: "2025-11-24",
    unpublish_at: "2026-04-27"
  },
  hauntedCarnival2025: {
    publish_at: "2025-09-24",
    unpublish_at: "2025-11-02T00:01:00"
  },
  hauntedCarnival2026: {
    publish_at: "2026-09-28",
    unpublish_at: "2026-11-01T03:00:00"
  },
  hotSeatsOctober2025: {
    publish_at: "2025-09-26",
    unpublish_at: "2025-10-20T00:02:00"
  },
  winAMillion2025: {
    publish_at: "2025-10-13",
    unpublish_at: "2026-01-02T21:00:00"
  },
  scavengerHunt2025: {
    publish_at: "2025-11-01",
    unpublish_at: "2026-01-01"
  },
  podcastFreePlay2026: {
    publish_at: "2026-01-27",
    unpublish_at: "2026-07-20"
  },
  openFortuneFreePlay2026: {
    publish_at: "2026-03-05",
    unpublish_at: "2026-07-21"
  },
  // Dining
  drunkenDragonClosingModal: {
    publish_at: "2026-04-07",
    unpublish_at: "2026-04-19T05:00:00"
  }
};

export default scheduleConfig;
